export let AdminMode = /*#__PURE__*/function (AdminMode) {
  AdminMode["Browse"] = "BROWSE";
  AdminMode["CreatingCart"] = "CREATING_CART";
  AdminMode["EditingCart"] = "EDITING_CART";
  return AdminMode;
}({});
export const ADMIN_PROCEED_BUTTON_TEXT = {
  [AdminMode.CreatingCart]: 'Create Cart URL Link',
  [AdminMode.EditingCart]: 'Save changes'
};